module.exports = __webpack_public_path__ + "img/2024-11-15d_1.963cee88.jpg";